import React, { FC, useState, useMemo } from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { DailyAgendaActions } from '../actions/actions';
import { DailyAgendaActionsProvider } from '../hooks/useDailyAgendaActions';
import { Widget as WidgetComponent } from './Widget';
import { WidgetViewModelProvider } from '../hooks/useWidgetViewModel';
import { WidgetViewModel } from '../viewModel/viewModel';
import { DatePickerProvider } from '../hooks/useDatePicker';

const Widget: FC<
  WidgetProps<{
    viewModel: WidgetViewModel;
    actions: DailyAgendaActions;
  }>
> = ({ actions, viewModel }) => {
  const selectedDateFromViewModel = new Date(
    `${viewModel.datePickerViewModel.selectedDate!}T00:00:00`,
  );
  const [currentDate, setCurrentDate] = useState(selectedDateFromViewModel);
  const [headerSize, setHeaderSize] = useState<{
    width?: number;
    height?: number;
  }>({});
  const contextValue = useMemo(
    () => ({ currentDate, setCurrentDate, headerSize, setHeaderSize }),
    [currentDate, headerSize],
  );

  return (
    <WidgetViewModelProvider value={viewModel}>
      <DailyAgendaActionsProvider value={actions}>
        <DatePickerProvider value={contextValue}>
          <WidgetComponent />
        </DatePickerProvider>
      </DailyAgendaActionsProvider>
    </WidgetViewModelProvider>
  );
};

export default Widget;
